'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'circle-plus';
var width = 512;
var height = 512;
var aliases = ["plus-circle"];
var unicode = 'f055';
var svgPathData = ['M16 256a240 240 0 1 0 480 0 240 240 0 1 0 -480 0zm128 0c0-4.4 3.6-8 8-8l96 0 0-96c0-4.4 3.6-8 8-8s8 3.6 8 8l0 96 96 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-96 0 0 96c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-96-96 0c-4.4 0-8-3.6-8-8z', 'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-8-152c0 4.4 3.6 8 8 8s8-3.6 8-8l0-96 96 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-96 0 0-96c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 96-96 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l96 0 0 96z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCirclePlus = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;